"use client";

import React, { useState, useEffect } from "react";

import { CardContent } from "./ui/card";
import { ArrowUpDown } from "lucide-react";
// import { Loader2 } from "lucide-react";
// import info from "../assets/images/system.png";
import { Button } from "./ui/button";
// import { CurrencySelector } from "../components/currencyDropdown2";
import { Lock, ChevronDown, X } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import coin from "../assets/images/placeholder/crypto-colour.png";
import { Skeleton } from "./ui/skeleton";
// import { Input } from "./ui/input";
import { useNotification } from "../context/NotificationProvider";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogClose,
} from "./ui/dialog";
import { beneficiaries } from "../data/mockTradeRates";
import {
  // getTradablePairs,
  // getTradeRate,
  // getWalletAddresses,
  // createWalletAddress,
  getAssetWallet,
  // createSendQuote,
} from "../services/digitalWalletService";
import { useToast } from "../hooks/use-toast";
import CurrencyFormatter from "../utils/currencyFormatter";
import { useTradeRate } from "../hooks/useTradeRate";
import {
  formatFiatWithTwoDecimals,
  truncateDecimals,
} from "../utils/numberFormatter";

const SendForex = ({
  currentRate,
  currencies,
  onChangeAmount,
  onSelectAsset,
  onSelectChain,
  setSelectedAsset,
  selectedAsset,
  destinationAddress,
  setDestinationAddress,
  onContinue,
  selectedNetwork,
  hotActionAsset,
  loadingOnContinue,
  setTagNumber,
  onhandleQuote,
  parentAmount,
  setAmountFlag,
  amountFlag,
  setIsSending,
  isSending,
  zarAmount,
}) => {
  // const [isAmountFocused, setIsAmountFocused] = useState(false);
  // const [isAddressFocused, setIsAddressFocused] = useState(false);
  // const [selectedBalance, setSelectedBalance] = useState(null);
  const [isSavedAddressesOpen, setIsSavedAddressesOpen] = useState(false);
  const [convertedValue, setConvertedValue] = useState(zarAmount);
  // const [newName, setNewName] = useState("");
  // const [newWalletId, setNewWalletId] = useState("");
  // const [newLastname, setNewLastname] = useState("");
  const [isBaseInput, setIsBaseInput] = useState(true);
  const [showAll, setShowAll] = useState(false);
  // const [addresses, setAddresses] = useState([]);
  // const [addressDetails, setAddressDetails] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermAddress, setSearchTermAddress] = useState("");
  const [open, setOpen] = useState(false);
  const [addBook, setAddBook] = useState([]);
  // const [tradePair, setTradePair] = useState([]);
  // const [selectedPair, setSelectedPair] = useState(null);
  const [rate, setRate] = useState(currentRate);
  // const [newAddress, setNewAddress] = useState(null);
  const [selectedChain] = useState(selectedNetwork);
  // const [baseCurrency, setBaseCurrency] = useState(null);
  const [tag, setTag] = useState(null);
  // const [quoteCurrency, setQuoteCurrency] = useState(null);
  // const [loading, setLoading] = useState(true);
  const [flag, setFlag] = useState(false);
  // const [tagFlag, setTagFlag] = useState(false);
  // const [error, setError] = useState(null);
  const [amount, setAmount] = useState(parentAmount);
  const [wallet, setWallet] = useState(null);
  const [isLoading] = useState(false);
  // const [availableAmount, setAvailableAmount] = useState(null);
  const { settings } = useAuth();
  const { toast } = useToast();
  const { showPersistentMessage } = useNotification();
  const isPostTrade = false;

  const defaultCurrency = settings?.preferences?.localCurrency || "ZAR";
  const minWithdrawal = parseFloat(10);
  // const pair =
  //   selectedAsset?.asset + "-" + defaultCurrency.toString().toLowerCase();

  const {
    data: tradeRate,
    // loadingTradeRate,
    // tradeRateError,
  } = useTradeRate(
    selectedAsset?.assetId,
    "sell",
    defaultCurrency,
    isPostTrade
  );

  // const addName = newName + " " + selectedAsset?.asset?.toUpperCase + " Wallet";

  // const addAddress = async () => {
  //   try {
  //     const newestAddress = {
  //       firstName: newName,
  //       lastName: newLastname,
  //       addressName: addName,
  //       walletAddress: newAddress,
  //       asset: selectedAsset?.assetId,
  //       assetName: selectedAsset?.assetName,
  //       chain: selectedChain?._id,
  //       chainName: selectedChain?.chain,
  //     };
  //     if (!newestAddress.asset) {
  //       return toast({
  //         description: "Please selected an asset and chain",
  //         variant: "eighty",
  //       });
  //     }
  //     const address = await createWalletAddress(newestAddress);
  //     if (address) {
  //       toast({
  //         description: "Address Added",
  //         variant: "eighty",
  //       });
  //       setIsSavedAddressesOpen(false);
  //       setNewLastname("");
  //       setNewName("");
  //       setNewAddress("");
  //     }
  //   } catch (error) {
  //     toast({
  //       description: `${error}`,
  //       variant: "eighty",
  //     });
  //     // setIsSavedAddressesOpen(false);
  //   }
  //   setAddresses("");
  // };

  useEffect(() => {
    if (!selectedAsset || selectedAsset.length <= 0) return;
    if (!tradeRate) return;
    const fetchRate = async () => {
      try {
        if (tradeRate) {
          setRate(tradeRate);
          if (onSelectAsset) {
            onSelectAsset(selectedAsset, tradeRate?.rate);
          }
        }
      } catch {
        // setError(err.message);
        showPersistentMessage(
          "error",
          "Trading rates are not available at the moment please try again later"
        );
      } finally {
        // setLoading(false);
      }
    };
    fetchRate();
  }, [tradeRate, onSelectAsset, selectedAsset, showPersistentMessage]);

  useEffect(() => {
    if (!beneficiaries) return;
    if (beneficiaries) {
      setAddBook(beneficiaries);
    }
  }, [isSavedAddressesOpen]);

  useEffect(() => {
    const number = parseFloat(amount || 0);
    if (!number) {
      setConvertedValue(0);
      return;
    }

    if (isBaseInput) {
      const convertedValue = number * rate?.rate;
      const formattedValue = parseFloat(convertedValue.toFixed(2));
      setConvertedValue(formattedValue);
      if (number < minWithdrawal) {
        setFlag(true);
        setIsSending(true);
      }
      if (number >= minWithdrawal) {
        setIsSending(false);
        setFlag(false);
      }
      if (onChangeAmount) {
        onChangeAmount(number, formattedValue);
      }
    } else {
      const convertedValue = number / rate?.rate;
      const asset = selectedAsset?.asset?.toLowerCase();
      const isTwoDecimalCurrency = asset === "usdc" || asset === "usdt";
      const formattedValue = isTwoDecimalCurrency
        ? parseFloat(convertedValue.toFixed(2))
        : convertedValue;
      setConvertedValue(formattedValue);
      if (formattedValue < minWithdrawal) {
        setFlag(true);
        setIsSending(true);
      }
      if (formattedValue >= minWithdrawal) {
        setIsSending(false);
        setFlag(false);
      }
      if (onChangeAmount) {
        onChangeAmount(formattedValue, number);
      }
    }
  }, [
    amount,
    rate,
    isBaseInput,
    minWithdrawal,
    onChangeAmount,
    setIsSending,
    selectedAsset,
  ]);

  // const SendQuoteArray = {
  //   amount: amount,
  //   cryptoAsset: selectedAsset?.asset,
  //   chain: selectedChain?._id,
  // };

  useEffect(() => {
    if (!selectedChain || !selectedChain.assetId || !selectedChain._id) return;

    const fetchWallet = async () => {
      // setLoading(true);
      // let actualWallet = [];
      // let noWallet = 0;

      try {
        const walletData = {
          assetId: selectedChain.assetId,
          chainId: selectedChain._id,
        };

        const data = await getAssetWallet(walletData);

        if (data?.data?.data) {
          // actualWallet = data.data.data;
          // noWallet = 0;
          setWallet(data.data.data);
        }
      } catch {
        // setError(err.message);
        // actualWallet = [];
        // noWallet = 1;
      } finally {
        // setLoading(false);
      }
    };

    fetchWallet();
  }, [selectedChain]);

  const onTagChange = (e) => {
    const newTag = e.target.value;
    if (/^\d*\.?\d*$/.test(newTag)) {
      if (wallet?.tag) {
        if (newTag === wallet?.tag) {
          setTag(newTag);
          setTagNumber(newTag);
          // setTagFlag(false);
        }
        if (newTag !== wallet?.tag) {
          setTag(newTag);
          setTagNumber(null);
          // setTagFlag(true);
        }
      }
      if (!wallet?.tag) {
        setTag(newTag);
        setTagNumber(newTag);
        // setTagFlag(false);
      }
    }
  };

  const onTextChange = (e) => {
    setAmountFlag(false);
    const newAmount = e.target.value;

    if (/^\d*\.?\d*$/.test(newAmount)) {
      if (newAmount < minWithdrawal) {
        setFlag(true);
        setIsSending(true);
        setAmount(newAmount);
      }
      if (newAmount >= minWithdrawal) {
        setIsSending(false);
        setFlag(false);
        setAmount(newAmount);
      }
    }
  };

  const maxQuoteAmount = () => {
    if (isBaseInput) {
      setAmount(selectedAsset?.availableAmount);
    } else {
      const newConverted = selectedAsset?.availableAmount;
      setAmount(newConverted * rate?.rate);
    }
  };

  const switchConversion = () => {
    setIsBaseInput((prev) => !prev);

    setAmount(convertedValue);
    setConvertedValue(amount || 0);
  };

  useEffect(() => {
    if (!hotActionAsset) return;
    setSelectedAsset(hotActionAsset);
  }, [hotActionAsset, setSelectedAsset]);
  const filteredAssets = currencies?.filter(
    (assets) =>
      assets?.asset?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      assets?.assetName?.toLowerCase().includes(searchTerm?.toLowerCase())
  );
  const filteredAddresses = addBook?.filter((address) =>
    address?.name?.toLowerCase().includes(searchTermAddress?.toLowerCase())
  );

  const handleSelect = (asset) => {
    if (asset?.asset === selectedAsset?.asset) {
      setSelectedAsset(asset);
      setOpen(false);
      return;
    }
    if (asset?.asset !== selectedAsset?.asset) {
      // setAwaitingRate(true);
      // setLoadingRate(true);
      setSelectedAsset(asset);
      // if (onSelect) {
      //   onSelect(asset);
      // }
      // if (onSelectedAsset) {
      //   onSelectedAsset();
      // }
      setOpen(false);
    }
  };
  // const handleChain = (net) => {
  //   const newChain = net;

  //   if (onSelectChain) {
  //     onSelectChain(newChain);
  //   }
  //   setSelectedChain(newChain);
  // };

  const handleSelectAddress = (address) => {
    setDestinationAddress(address);
    setIsSavedAddressesOpen(false);
  };

  const getInitials = (name, lastname) => {
    const firstInitial = name?.charAt(0).toUpperCase() || "";
    const lastInitial = lastname?.charAt(0).toUpperCase() || "";
    return firstInitial + lastInitial;
  };

  const handleSend = () => {
    if (!selectedAsset) {
      toast({
        description: "Please select an asset.",
        variant: "eighty",
      });
      return;
    }

    const parsedAmount = parseFloat(amount);
    if (!amount || isNaN(parsedAmount) || parsedAmount <= 0) {
      toast({
        description: "Please enter a valid amount greater than zero.",
        variant: "eighty",
      });
      return;
    }

    if (!destinationAddress) {
      toast({
        description: "Please enter a valid wallet address.",
        variant: "eighty",
      });
      return;
    }
    onhandleQuote();
    setIsSending(true);
  };
  const formatter = new CurrencyFormatter();
  return (
    <CardContent>
      <div className="grid grid-cols-4 gap-4 grid-rows-1 py-8">
        <div className="space-y-2 col-span-1">
          <label className="text-gray-600 text-sm">Select asset</label>
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
              {isLoading ? (
                <div className="w-full flex items-center justify-between py-4  px-4 rounded-2xl border border-gray-300 bg-muted/50">
                  <div className="flex items-center gap-3 ">
                    <Skeleton className="w-10 h-10 rounded-full bg-gray-300" />

                    <div className="flex flex-col gap-1">
                      <Skeleton className="w-10 h-5 rounded-full bg-gray-300" />
                    </div>
                  </div>
                  <Skeleton className="w-6 h-6 rounded-full bg-gray-300" />
                </div>
              ) : (
                <Button
                  disabled={false}
                  variant="outline"
                  className="w-full flex items-center justify-between py-8 rounded-2xl hover:border-brand-primary transition-colors"
                >
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10  rounded-full flex items-center justify-center">
                      {selectedAsset ? (
                        <img
                          src={selectedAsset?.assetIcon}
                          alt={selectedAsset?.assetName}
                          width={32}
                          height={32}
                          className="text-white"
                        />
                      ) : (
                        <img
                          src={coin}
                          alt={"Default Asset"}
                          width={32}
                          height={32}
                          className="text-white"
                        />
                      )}
                    </div>
                    <div className="text-left">
                      <div className="font-semibold">
                        {selectedAsset?.asset.toUpperCase()}
                      </div>
                      <div className="text-gray-600">
                        {selectedAsset?.assetName
                          ? selectedAsset.assetName.length > 10
                            ? selectedAsset.assetName.slice(0, 10) + "..."
                            : selectedAsset.assetName
                          : "Select..."}
                      </div>
                    </div>
                  </div>
                  <ChevronDown className="text-gray-400" />
                </Button>
              )}
            </DialogTrigger>

            <DialogContent className="max-w-sm rounded-2xl p-6">
              <DialogClose asChild>
                <Button
                  variant="ghost"
                  onClick={() => setOpen(false)}
                  className="w-10 h-10 absolute top-4 right-4 text-gray-400 hover:text-gray-600 rounded-full p-0 flex items-center justify-center border border-gray-200 hover:bg-gray-100"
                >
                  <X size={18} className="text-gray-700" />
                </Button>
              </DialogClose>

              <DialogHeader>
                <DialogTitle className="text-lg font-semibold text-gray-800">
                  Select an Asset
                </DialogTitle>
              </DialogHeader>
              <div className="mt-4">
                <input
                  type="text"
                  placeholder="Search addresses..."
                  className="w-full border rounded-lg px-3 py-2"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="mt-4 flex flex-col space-y-3 max-h-72 overflow-y-auto">
                {currencies &&
                  filteredAssets?.map((asset) => {
                    return (
                      <button
                        key={asset.assetId}
                        onClick={() => {
                          handleSelect(asset);
                        }}
                        className="flex items-center gap-3 justify-between px-3 py-3 border rounded-lg border-transparent bg-gray-50 hover:border-rose-200"
                      >
                        <div className="flex items-center gap-3">
                          <img
                            src={asset.assetIcon}
                            alt={asset.assetName}
                            className="w-6 h-6"
                          />
                          <div className="flex flex-col text-left">
                            <span>{asset.assetName}</span>
                            <span className="text-xs text-gray-500">
                              {asset.asset?.toUpperCase()}
                            </span>
                          </div>
                        </div>
                        <div className="flex flex-col text-right">
                          <span className="font-bold">
                            {formatter.format(
                              asset.availableAmount,
                              asset.asset?.toUpperCase()
                            )}
                          </span>
                          <span className="text-xs text-gray-500">
                            {asset.valueInLocalCurrency
                              ? formatFiatWithTwoDecimals(
                                  asset.valueInLocalCurrency
                                )
                              : "R 0.00"}
                          </span>
                        </div>
                      </button>
                    );
                  })}
              </div>
            </DialogContent>
          </Dialog>
        </div>
        <div className="space-y-2 col-span-3">
          <label className="text-gray-600 text-sm">Available balance</label>
          <div className="p-5 rounded-2xl bg-gray-50 flex-1 flex items-center">
            <div className="text-xl font-semibold text-gray-600">
              {selectedAsset?.availableAmountFormatted}
            </div>
          </div>
        </div>
      </div>

      <div className="mt-6 mb-6 w-full">
        <label className="block text-sm font-medium text-gray-800 mb-2">
          Enter amount
        </label>

        <div className="space-y-2">
          <div
            className={`flex items-center gap-4 rounded-2xl p-3 border ${
              flag ? "border-2 border-rose-500 " : " "
            }`}
          >
            <input
              type="text"
              value={amount}
              onChange={onTextChange}
              className={`flex-1 text-base md:text-sm font-semibold bg-transparent outline-none 
    focus-visible:ring-0 focus-visible:outline-none transition-colors duration-200 ease-in-out
    ${flag ? "text-rose-500" : "text-brand-primary"}`}
              placeholder="Enter amount"
            />

            <div className="text-gray-500">
              ≈{" "}
              {convertedValue === " " ||
              isNaN(parseFloat(String(convertedValue)))
                ? (() => {
                    if (isBaseInput) {
                      return "0.00";
                    }
                    const asset = selectedAsset?.asset?.toLowerCase();
                    const isTwoDecimalCurrency =
                      asset === "usdc" || asset === "usdt";
                    return isTwoDecimalCurrency ? "0.00" : "0.000000";
                  })()
                : (() => {
                    if (isBaseInput) {
                      return truncateDecimals(
                        parseFloat(String(convertedValue)),
                        2
                      );
                    } else {
                      const asset = selectedAsset?.asset?.toLowerCase();
                      const isTwoDecimalCurrency =
                        asset === "usdc" || asset === "usdt";
                      const decimals = isTwoDecimalCurrency ? 2 : 8;
                      return truncateDecimals(
                        parseFloat(String(convertedValue)),
                        decimals
                      );
                    }
                  })()}{" "}
              {isBaseInput
                ? defaultCurrency.toUpperCase()
                : selectedAsset?.asset.toUpperCase()}{" "}
            </div>
            <div className="flex items-center gap-2">
              <Button
                onClick={switchConversion}
                variant="outline"
                size="icon"
                className="rounded-full"
              >
                <ArrowUpDown className="h-4 w-4" />
              </Button>
              <Button
                onClick={maxQuoteAmount}
                variant="outline"
                className="rounded-full"
              >
                Max
              </Button>
            </div>
          </div>
          {flag ? (
            <p className="mt-1 text-sm text-rose-500">
              This amount is lower minimum send{" "}
              {selectedChain?.minimumWithdrawal?.$numberDecimal}
            </p>
          ) : (
            amountFlag && (
              <p className="mt-1 text-sm text-rose-500">
                Total amount with fee exceeds your asset balance
              </p>
            )
          )}
          {selectedAsset?.asset === "xrp" && (
            <>
              <label className="block text-sm font-medium text-gray-800 mb-2">
                Tag Number
              </label>
              <div
                className={`flex items-center w-80 gap-4 rounded-2xl p-3 border`}
              >
                <input
                  type="text"
                  value={tag}
                  onChange={onTagChange}
                  className="flex-1 text-base md:text-sm font-semibold bg-transparent outline-none focus-visible:ring-0 focus-visible:outline-none transition-colors duration-200 ease-in-out text-brand-primary"
                  placeholder="Enter tag number"
                />
              </div>
            </>
          )}
        </div>
      </div>

      <div className="mb-6 w-full">
        <label className="block text-sm font-medium text-gray-800 mb-2">
          Send to
        </label>

        <div className="border rounded-lg px-4 py-2 bg-gray-50 flex items-center">
          <input
            type="text"
            placeholder="Select a Beneficiary..."
            className="flex-1 outline-none bg-transparent text-sm text-gray-800"
            value={destinationAddress?.accountNumber}
            onChange={(e) => setDestinationAddress(e.target.value)}
          />

          <Dialog
            open={isSavedAddressesOpen}
            onOpenChange={setIsSavedAddressesOpen}
          >
            <DialogTrigger asChild>
              <Button variant="link" className="text-xs text-rose-600">
                Saved Beneficiaries
              </Button>
            </DialogTrigger>
            <DialogContent
              className="max-w-md rounded-lg"
              aria-describedby="saved-addresses-description"
            >
              <DialogHeader>
                <DialogTitle className="text-lg font-semibold">
                  {"Select a saved address"}
                </DialogTitle>
              </DialogHeader>
              <div id="saved-addresses-description" className="mt-1">
                <span className="text-xs text-gray-500">
                  Showing contacts for the selected asset and network
                </span>
                <div className="justify-between border rounded-lg px-4 py-3 mb-5 mt-1 bg-gray-50 flex items-center">
                  <div className="flex items-center">
                    <img
                      src={selectedAsset?.assetIcon}
                      alt="Asset"
                      width={20}
                      height={20}
                    />
                    <span className="ml-1 font-semibold">
                      {selectedAsset?.assetName}
                    </span>
                  </div>
                  <span className="ml-4 inline-flex items-center gap-x-1.5 py-0.5 px-3 rounded-full text-xs font-bold bg-gray-200 text-gray-700 cursor-pointer">
                    <img
                      src={selectedAsset?.assetIcon}
                      alt="Asset"
                      width={12}
                      height={12}
                    />
                    {selectedChain ? selectedChain?.chain?.toUpperCase() : ""}
                  </span>
                </div>
                <div className="mb-4">
                  <input
                    type="text"
                    placeholder="Search addresses..."
                    className="w-full border rounded-lg px-3 py-2"
                    value={searchTermAddress}
                    onChange={(e) => setSearchTermAddress(e.target.value)}
                  />
                </div>

                <ul className="mt-4 space-y-3 max-h-40 overflow-y-auto">
                  {addBook ? (
                    filteredAddresses.map((addr) => (
                      <li
                        key={addr._id}
                        className="border rounded-lg p-3 bg-gray-50 hover:border-rose-300 cursor-pointer"
                        onClick={() => handleSelectAddress(addr)}
                      >
                        <div className="flex items-center gap-2">
                          <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-pink text-white font-medium text-md">
                            {(() => {
                              const parts = addr.name.trim().split(" ");
                              const firstName = parts[0];
                              const lastName = parts.slice(1).join(" ");
                              return getInitials(firstName, lastName);
                            })()}
                          </div>
                          <div>
                            <p className="text-sm font-semibold text-gray-800">
                              {addr.name || "Anonymous"}{" "}
                            </p>
                            <p className="text-xs text-gray-600 break-all">
                              {addr.bank}
                            </p>
                          </div>
                        </div>
                      </li>
                    ))
                  ) : (
                    <p className="text-center text-gray-500">
                      No Addresses saved{" "}
                    </p>
                  )}
                </ul>
                {
                  <div className="mt-1 text-center">
                    {showAll ? (
                      <Button
                        variant="link"
                        className="text-xs text-rose-600"
                        onClick={() => setShowAll(false)}
                      >
                        Show less
                      </Button>
                    ) : (
                      <Button
                        variant="link"
                        className="text-xs text-rose-600"
                        onClick={() => setShowAll(true)}
                      >
                        See more
                      </Button>
                    )}
                  </div>
                }
                {/* <div className="mt-6 border-t pt-4">
                  <p className="font-semibold text-gray-800 mb-2">
                    {"Add New Wallet Address"}
                  </p>

                  <>
                    <input
                      type="text"
                      placeholder="Name"
                      className="w-full border rounded-lg px-3 py-2 mb-2"
                      value={newName}
                      onChange={(e) => setNewName(e.target.value)}
                    />
                    <input
                      type="text"
                      placeholder="Lastname"
                      className="w-full border rounded-lg px-3 py-2 mb-2"
                      value={newLastname}
                      onChange={(e) => setNewLastname(e.target.value)}
                    />

                    <input
                      type="text"
                      placeholder={"Enter wallet address"}
                      className="w-full border rounded-lg px-3 py-2 mb-2"
                      value={newAddress}
                      onChange={(e) => setNewAddress(e.target.value)}
                    />
                    <Button
                      onClick={addAddress}
                      className="w-full mt-2 bg-gradient-to-tr from-purple-500 to-rose-500 rounded-full"
                    >
                      Create Address
                    </Button>
                  </>
                </div> */}
              </div>
            </DialogContent>
          </Dialog>
        </div>
      </div>

      <Button
        onClick={handleSend}
        disabled={isSending}
        className="w-full py-4 h-15 bg-gradient-to-tr from-purple-500 to-rose-500 text-white rounded-full font-bold"
      >
        Continue
      </Button>

      <div className="text-center text-sm text-gray-500 mt-6 flex items-center justify-center">
        <Lock size={10} className="mr-2" />
        <p>Secured by 80Eight</p>
      </div>
    </CardContent>
  );
};

export default SendForex;
